module.exports = "/images/close.svg?10ba6081e22946e4369a82f6832b432a";